<template>
  <base-loader :loading="loadingData">
    <details-component
      :action="$t(`buttons.${[process]}`)"
      :clients="clients"
      :currencies="currencies"
      :loading="loadingContent"
      :loading-select="isLoadingSelect"
      :managers="managers"
      :data="paymentData"
      @confirm="doPayment"
      @requestClients="getClients">
    </details-component>
  </base-loader>
</template>

<script>
  import DetailsComponent from "../../components/maintenancePayments/MaintenancePaymentDetailsComponent"
  import Payments from "../../services/MaintenancePayments"
  import Projects from "../../services/Projects"
  import Clients from "../../services/Clients"

  export default {
    name: 'MaintenancePaymentDetails',
    components: {
      DetailsComponent
    },
    data () {
      return {
        paymentData: {
          client: {},
          currency: 'EURO',
          type: 'EARNING',
        },
        paymentId: null,
        clients: [],
        managers: [],
        currencies: [],
        isLoadingSelect: false,
        loadingContent: false,
        loadingData: false
      }
    },
    computed: {
      formattedData () {
        let paymentData = Object.assign({}, this.paymentData);
        if (paymentData.client) {
          paymentData.client_id = paymentData.client.id;
        }
        delete paymentData.client;
        return paymentData
      },
      process () {
        return (this.paymentId) ? 'update' : 'create'
      }
    },
    methods: {
      doPayment () {
        if (this.process === 'update') {
          this.updatePayment()
        } else {
          this.createPayment()
        }
      },
      createPayment () {
        this.loadingContent = true;
        Payments.create(this.formattedData).then(() => {
          this.$notificationService.success(`${this.$t('maintenancePayments.maintenancePayment')} ${this.$t('maintenancePayments.successCreate')}`);
          history.back();
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => {
          this.loadingContent = false
        })
      },
      updatePayment () {
        this.loadingContent = true;
        Payments.update(this.formattedData).then(() => {
          this.$notificationService.success(`${this.$t('maintenancePayments.maintenancePayment')} ${this.$t('maintenancePayments.successUpdate')}`);
          history.back();
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => {
          this.loadingContent = false
        })
      },
      getPaymentDetails () {
        this.loadingData = true;
        Payments.details(this.paymentId).then((res) => {
          this.paymentData = res.data
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => {
          this.loadingData = false
        })
      },
      getManagers () {
        Payments.getManagers().then((res) => {
          this.managers = res.data
        })
      },
      getCurrencies () {
        Projects.getCurrencies().then((res) => {
          this.currencies = res;
        })
      },
      getClients (query) {
        this.isLoadingSelect = true;
        Clients.list(query).then((res) => {
          this.clients = res.data;
          this.isLoadingSelect = false
        })
      }
    },
    mounted () {
      this.paymentId = parseInt(this.$route.params.id);
      this.getCurrencies();
      if (this.process === 'update') {
        this.getPaymentDetails()
      }
    }
  }
</script>

<style scoped>

</style>
